export const FeesRef = [
    "Unknown",
    "Paying UK/EU fees",
    "Paying overseas fees",
    "Paying UK/EU fees",
    "Paying overseas fees",
    "Paying UK/EU fees"
];